import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription, debounceTime, distinctUntilChanged } from 'rxjs';
import { AppConstant, RESPONSE_CODE } from 'src/app/helper/class/app-constant';
import { MENU_ITEMS } from 'src/app/helper/class/page-menu';
import { UrlServices } from 'src/app/helper/class/url-services';
import { isEmptyObj } from 'src/app/helper/class/utilityHelper';
import { menu } from 'src/app/helper/interface/menu-interface';
import { ResponseData } from 'src/app/helper/interface/response';
import { User } from 'src/app/helper/interface/user';
import { AuthService } from 'src/app/helper/service/auth.service';
import { DashboardService } from 'src/app/modules/service/dashboard.service';
import { UserApiService } from 'src/app/modules/user/services/user-api.service';
import { ModalService } from 'src/app/shared/service/modal.service';
import { NavigationService } from '../../service/navigation.service';
import { ChangePasswordComponent } from '../change-password/change-password.component';
import { MasterApiService } from 'src/app/modules/master/service/master-api.service';
import { ManageUserComponent } from 'src/app/modules/user/page/manage-user/manage-user.component';
import { EditUserComponent } from 'src/app/modules/user/component/edit-user/edit-user.component';
import { GetTokenComponent } from 'src/app/modules/component/widget/get-token/get-token.component';
import { ProfileComponent } from 'src/app/modules/user/component/profile/profile.component';
import { Confirmation, ConfirmEventType } from 'primeng/api';
import { AuthApiService } from '../../service/auth-api.service';
import { s } from '@fullcalendar/core/internal-common';


@Component({
  selector: 'app-user-header',
  templateUrl: './user-header.component.html',
  styleUrls: ['./user-header.component.scss'],
})
export class UserHeaderComponent implements OnInit {
  @Input() image: string = ''
  menu: any;
  selected: boolean = false;
  loading: boolean = false;
  urlService: any = UrlServices.PAGE_URL;
  SEARCH_RESULT: Array<any> = [];
  logo = this.auth.currentSettingValue?.logo_path;
  title = this.auth.currentSettingValue?.companyName;
  theme_color = this.auth.currentSettingValue?.theme_color || '#a5bdfd';
  user: User = this.auth.currentUserValue;
  roleName = 'User';
  searchControl: FormControl = new FormControl();
  searchDropDown: FormControl = new FormControl('Patient');
  currentTab = '';
  isMenuOpened: boolean = false;
  searchSub: Subscription = {} as Subscription;
  resultData: Array<any> = [];
  displayData: any[] = []
  showHeader: boolean = true;
  profile: string = '';
  formData: any[] = [
    {
      groupTitle: 'Select Doctor to get Token or View Patient directly',
      colName: 'doctor_fk_id',
      title: 'Doctor Name',
      type: 'select',
      col_size: 12,
      apiTblName: 'doctor',
      selectKeyName: 'fname',
      selectPrimaryKey: 'user_id',
      validator: [{ name: 'required', error: 'If you want to get token select Doctor Name' }],
      event: { name: 'change', isCallback: true }
    },
  ]
  constructor(
    private auth: AuthService,
    private modalService: ModalService,
    private dashboardService: DashboardService,
    private userApiServe: UserApiService,
    private router: Router,
    private navServe: NavigationService,
    private masterServe: MasterApiService,
    private authApi: AuthApiService,
  ) { }

  ngOnInit(): void {
    this.setUserMenus();
    this.router.events.subscribe(value => {
      const p = this.router.url.toString().split('/');
      this.currentTab = p[0] ? p[0] : p[1] || '';
    });
    if (typeof this.searchSub.unsubscribe == "function") {
      this.searchSub?.unsubscribe();
    }
    this.searchSub = this.searchControl.valueChanges.pipe(debounceTime(400), distinctUntilChanged()).subscribe(v => {
      console.log('on search ', v)
      if (v) {
        this.searchData(v);
      } else {
        this.showPanel = false;
        this.resultData = [];
      }
    })

    this.logoImage();

    const currentUrl = this.router.url;
    this.showHeader = !currentUrl.includes('/appointment/appointment_status');
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.showHeader = !event.urlAfterRedirects.includes(
          '/appointment/appointment_status'
        );
      }
    });

  }
  getDisplay() {
    this.masterServe.getFullData('counter', []).then((res: ResponseData) => {
      this.displayData = res.result;
    })
  }
  openDisplay(d: any) {
    if (d.id) {
      this.router.navigate([], { queryParams: { id: d.id } }).then(res => {
        window.open(`/${UrlServices.DISPLAY_ROUTE}?id=${d.id}`, '_blank');
      })
    }
  }

  ngAfterViewInit() {
    this.dashboardService.getAllTodaysToken();
    this.getDisplay();
  }
  showPanel: boolean = false;
  searchData(val: any) {
    let API: any;
    switch (this.searchDropDown.value) {
      case 'Patient':
        API = this.userApiServe.searchPatient(val);
        break;
      case 'Invoice':
        API = this.userApiServe.invoiceSearch(val);
        break;
    }
    this.showPanel = true;
    API.then((res: ResponseData | any) => {
      if (res.statusCode == RESPONSE_CODE.SUCCESS) {
        this.resultData = res.result;
      }
    });
  }
  selectSearch(id) {
    switch (this.searchDropDown.value) {
      case 'Patient':
        if (id) {
          this.modalService.openConfirmDialog(
            {
              title: 'View or Token',
              formField: this.formData, isFormField: true,
              btnOK: 'Get Token',
              btnCancel: 'View Patient'
            }).then((res: any) => {
              if (res) {
                this.dashboardService.getToken(id, res.doctor_fk_id);
              }
              else {
                this.navServe.goTo(this.urlService.PATIENT.PATIENT_TREATMENT.URL, { id: id })
              }
            })
        }
        break;
      case 'Invoice':
        this.navServe.goTo(this.urlService.INVOICE.PAYMENTVIEW.URL, { id: id })
        break;

    }
    this.showPanel = false;
    this.searchControl.setValue('');
  }

  checkPermission(item: any) {
    if (isEmptyObj(item.data?.permission)) {
      return 'empty';
    }
    const mName = item.data?.permission.moduleName;
    const aName = item.data?.permission.actionName;
    const per = this.auth.checkPermission(mName, aName);
    return per;
  }
  classActive: boolean = false;
  activeToggle() {
    this.classActive = true;
  }

  setUserMenus() {
    const filterRoles: any = [],
      menuItems: menu[] = [] as menu[];

    MENU_ITEMS.forEach((item, index) => {
      const pM = this.checkPermission(item);
      if (!pM) {
        return;
      }
      if (item.children?.length) {
        const chMenu: any = [];
        if (!chMenu.length) {
          return;
        }
        item.children = chMenu;
      }
      menuItems.push(item);
    });
    this.menu = menuItems;
  }

  toggleMenu(): void {
    this.isMenuOpened = !this.isMenuOpened;
  }
  clickedOutside(): void {
    this.isMenuOpened = false;
  }

  openChangePassword() {
    this.modalService
      .openModal(ChangePasswordComponent, {}, 'modal-md')
      .then((res) => {
        if (res) {
          this.auth.logout();
        }
      });
  }

  openUserProfile() {
    this.modalService
      .openModal(ProfileComponent, {}, 'modal-xl')
      .then((res) => {
        if (res) {
          this.auth.logout();
        }
      });
  }

  logout() {
    const config: Confirmation = {
      message: 'Are you sure you want to logout?',
    };
    this.modalService.openConfirmDialog(config).then((res: boolean) => {
      if (res) {
        this.auth.logout();
      }
    });
  }

  logoImage() {
    this.authApi.getSetting().then((res: any) => {
      console.log('login res', res.result.theme_color);
      this.profile = res.result.logo_path;
      console.log('profile', this.profile);

      this.theme_color = res.result.theme_color || '#a5bdfd';
    });
  }
}
